
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/teamMembers';
import { actions } from './teamMembersList.slice';
import {
  TeamMembersListFetchAction,
  TeamMembersListDeleteAction,
  TeamMembersListAllFetchAction,
} from './teamMembersList.types';
import { Resp, dispatch } from '../helpers';
import axios from 'axios';
import { runToast } from '../tools';

export function* fetchTeamMembersListWorker(
  action: TeamMembersListFetchAction
) {
  try {
    const response: Resp<typeof api.fetchTeamMemberList> = yield call(
      api.fetchTeamMemberList,
      action.payload.clinicalTrialId,
      action.payload.args
    );
    yield dispatch(actions.fetchTeamMembersListSuccess(response?.data));
  } catch (error) {
    yield dispatch(actions.fetchTeamMembersListFailure(error as Error));
  }
}

export function* fetchTeamMembersListAllWorker(
  action: TeamMembersListAllFetchAction
) {
  try {
    const response: Resp<typeof api.fetchTeamMemberListAll> = yield call(
      api.fetchTeamMemberListAll,
      action.payload.clinicalTrialId
    );
    yield dispatch(actions.fetchTeamMembersListAllSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchTeamMembersListAllFailure(error as Error));
  }
}

export function* deleteTeamMemberWorker(action: TeamMembersListDeleteAction) {
  try {
    const { clinicalTrialId, teamMemberId } = action.payload;
    yield call(api.deleteTeamMember, clinicalTrialId, teamMemberId);
    yield dispatch(
      actions.deleteTeamMemberSuccess({
        clinicalTrialId,
      })
    );
    yield call(runToast, 'success', 'Member deleted successfully');
  } catch (e) {
    yield dispatch(actions.deleteTeamMemberFailure(e as Error));
    if (axios.isAxiosError(e) && e.response?.status === 400) {
      yield call(runToast, 'error', e.response?.data?.detail);
      return;
    }
    yield call(runToast, 'error', 'Failed to delete member');
  }
}

export function* teamMembersListSaga() {
  yield takeLatest(
    actions.fetchTeamMembersList.type,
    fetchTeamMembersListWorker
  );

  yield takeLatest(actions.deleteTeamMember.type, deleteTeamMemberWorker);
  yield takeLatest(
    actions.fetchTeamMembersListAll.type,
    fetchTeamMembersListAllWorker
  );
}
